import * as Styled from "./styled"
import { Props, CategorizedOption, Option } from "./types"

const Options = ({ options, onOptionClick, selected }: Props) => {
  const isCategorizedOption = options[0] && 'title' in options[0]

  return (
    <Styled.Wrapper >
      <Styled.Container data-testid="category-options">
        {isCategorizedOption ?
          (options as CategorizedOption[]).map((category, index) =>
            <div key={index}>
              <Styled.Title>{category.title}</Styled.Title>
              {category.options.map((option, index) => <Styled.Radio data-testid={`categorized-option-${option.label}`} key={index} checked={selected.value == option.value} label={option.label} onClick={() => onOptionClick(option)} />)}
            </div>) :
          (options as Option[]).map(option => <Styled.Radio data-testid={`category-option-${option.label}`} checked={selected.value == option.value} label={option.label} onClick={() => onOptionClick(option)} />)}
      </Styled.Container>
    </Styled.Wrapper>
  )
}

export default Options
